import { useGetInvoicesById } from "@portal/queries/invoice-query";
import { useSearchParams } from "react-router-dom";

function useEntityQueryParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const entityAction = searchParams.get("entity_action");
  const entityType = searchParams.get("entity_type");
  const invoiceIds = searchParams.get("invoice_ids");
  const { data, isLoading } = useGetInvoicesById(
    invoiceIds ? [invoiceIds] : undefined,
    true
  );
  const queryParams = {
    entity_action: entityAction,
    entity_type: entityType,
    invoice_ids: invoiceIds,
  };

  function handleClear() {
    setSearchParams();
  }

  const isDisputeAction = entityAction === "CREATE" && entityType === "DISPUTE";
  const isPTPAction =
    entityAction === "CREATE" && entityType === "PROMISE_TO_PAY";

  return {
    disputeQueryParams: queryParams,
    ptpQueryParams: queryParams,
    handleClear,
    isDisputeAction,
    isPTPAction,
    defaultValue: data?.list,
    isLoading,
  };
}

export default useEntityQueryParams;
